import styles from './ModalWrapper.module.css';

const ModalWrapper = ({ isOpen, onClose, onSkip, children }) => {
	if (!isOpen) return null;

	const handleClose = onSkip || onClose;

	return (
		<div className={styles.modalOverlay} onClick={handleClose}>
			<div className={styles.modalContent} onClick={e => e.stopPropagation()}>
				<button className={styles.closeButton} onClick={handleClose}>
					&times;
				</button>
				{children}
			</div>
		</div>
	);
};

export default ModalWrapper;
